import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import {metrics} from '~/vendor/metrics';

import {getAnchorStyle} from '~/selectors/ProductSelectors';

import DecorationTypeTips from '~/shared/components/DecorationTypeTips';

import oneColorDesignImg from '~/assets/images/debossing/one_color_design.png';
import gradientDesignImg from '~/assets/images/debossing/gradient_design.png';

import './index.scss';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
const DebossModal = ({dismiss}) => {
  const product = useSelector(getAnchorStyle);

  useEffect(() => {
    metrics.pageViewTag('/ndx/designtip/debossing');
  }, []);

  const handleProductLink = () => {
    metrics.pageViewTag('/ndx/designtip/debossing/browseproducts');
  };

  const handleClose = () => {
    metrics.pageViewTag('/ndx/designtip/debossing/close');
  };

  const handleDone = () => {
    metrics.pageViewTag('/ndx/designtip/debossing/confirm');
  };

  const handleHelpLink = () => {
    metrics.pageViewTag('/ndx/designtip/debossing/help');
  };

  return (
    <DecorationTypeTips
      customClasses="ndx-DebossModal"
      title="Design Tips for Debossed Products"
      description="Debossing creates a recessed image by heat pressing your design onto the surface of your product using no ink colors. Your design will be representative of the debossing technique. Stick to these recommendations when adding your design"
      oneColorDesignImage={oneColorDesignImg}
      gradientDesignImg={gradientDesignImg}
      product={product}
      dismiss={dismiss}
      callbackHandleClose={handleClose}
      callbackHandleDone={handleDone}
      callbackHandleHelpLink={handleHelpLink}
      callbackHandleProductLink={handleProductLink}
    />
  );
};

DebossModal.displayName = 'DebossModal';
const propTypes = {
  dismiss: PropTypes.func
};

DebossModal.propTypes = propTypes;

export default DebossModal;
